import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const namespaced = true

const state = {

  views: {
    component: {
      fetching: false
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/knowledgechecks/index.js